export const LOGO_DEV_TOKEN = "pk_QK59ajPKQVCBSkDQ15YIqA";

export const PLATFORMS = [
  {
    key: "bookmyshow",
    name: "BookMyShow",
    shortName: "BookMyShow",
    category: "india",
    domain: "in.bookmyshow.com",
    aliases: ["bookmyshow", "bms", "in.bookmyshow.com", "bookmyshow.com"],
    regexes: [
      /^https?:\/\/(?:www\.)?(?:in\.)?bookmyshow\.com(?:\/.*)?$/i,
      /^https?:\/\/(?:www\.)?bookmyshow\.com(?:\/.*)?$/i,
    ],
    brandColor: "#EC1C24",
    brandBg: "#FEF2F2",
  },
  {
    key: "district",
    name: "District",
    shortName: "District",
    category: "india",
    domain: "district.in",
    aliases: ["district", "district.in", "district_in", "disctrict"],
    regexes: [
      /^https?:\/\/(?:www\.)?district\.in(?:\/.*)?$/i,
      /^https?:\/\/(?:www\.)?district\.in\/events\/[^/?#]+/i,
    ],
    brandColor: "#E23744",
    brandBg: "#FFF1F2",
  },
  {
    key: "allevents",
    name: "AllEvents",
    shortName: "AllEvents",
    category: "india",
    domain: "allevents.in",
    aliases: ["allevents", "allevents.in", "allevents.by", "allevents.com"],
    regexes: [/^https?:\/\/(?:www\.)?allevents\.[a-z.]+(?:\/.*)?$/i],
    brandColor: "#1E6091",
    brandBg: "#EFF6FF",
  },
  {
    key: "eventbrite",
    name: "Eventbrite",
    shortName: "Eventbrite",
    category: "global",
    domain: "eventbrite.com",
    aliases: ["eventbrite", "eventbrite.com"],
    regexes: [
      /^https?:\/\/(?:www\.)?eventbrite\.[a-z.]+\/e\/[^/?#]+-tickets-\d+/i,
      /^https?:\/\/(?:www\.)?eventbrite\.[a-z.]+(?:\/.*)?$/i,
    ],
    brandColor: "#F05537",
    brandBg: "#FFF1EE",
  },
  {
    key: "platinumlist",
    name: "Platinumlist",
    shortName: "Platinumlist",
    category: "global",
    domain: "platinumlist.net",
    aliases: [
      "platinumlist",
      "platinumlist.net",
      "platinumusit",
      "platinumlist.net-logo",
    ],
    regexes: [/^https?:\/\/(?:[a-z0-9-]+\.)?platinumlist\.net(?:\/.*)?$/i],
    brandColor: "#00B4D8",
    brandBg: "#EFF6FF",
  },

  // ---------------------------------------------------------------------------
  // 🇮🇳 Gujarat-Based Platforms & Regional Discovery
  // ---------------------------------------------------------------------------
  {
    key: "showmates",
    name: "Showmates",
    shortName: "Showmates",
    category: "gujarat",
    domain: "showmates.in",
    aliases: ["showmates", "showmates.in", "showmates.in-logo"],
    regexes: [/^https?:\/\/(?:www\.)?showmates\.in(?:\/.*)?$/i],
    brandColor: "#E11D48",
    brandBg: "#FFF1F2",
  },
  {
    key: "bookmybeats",
    name: "BookMyBeats",
    shortName: "BookMyBeats",
    category: "gujarat",
    domain: "bookmybeats.com",
    aliases: ["bookmybeats", "bookmybeats.com"],
    regexes: [/^https?:\/\/(?:www\.)?bookmybeats\.[a-z.]+(?:\/.*)?$/i],
    brandColor: "#EC4899",
    brandBg: "#FDF2F8",
  },
  {
    key: "ahmedabadmirror",
    name: "Ahmedabad Mirror",
    shortName: "Ahmedabad Mirror",
    category: "gujarat",
    domain: "ahmedabadmirror.com",
    aliases: ["ahmedabadmirror", "ahmedabadmirror.com"],
    regexes: [/^https?:\/\/(?:www\.)?ahmedabadmirror\.com(?:\/.*)?$/i],
    brandColor: "#DC2626",
    brandBg: "#FEF2F2",
  },
  {
    key: "ahmedabadcity",
    name: "Ahmedabad City",
    shortName: "Ahmedabad City",
    category: "gujarat",
    domain: "ahmedabadcity.com",
    aliases: ["ahmedabadcity", "ahmedabadcity.com"],
    regexes: [/^https?:\/\/(?:www\.)?ahmedabadcity\.com(?:\/.*)?$/i],
    brandColor: "#0284C7",
    brandBg: "#EFF6FF",
  },
  {
    key: "gujaratevents",
    name: "Gujarat Events",
    shortName: "Gujarat Events",
    category: "gujarat",
    domain: "gujaratevents.com",
    aliases: ["gujaratevents", "gujaratevents.com"],
    regexes: [/^https?:\/\/(?:www\.)?gujaratevents\.com(?:\/.*)?$/i],
    brandColor: "#D97706",
    brandBg: "#FFFBEB",
  },
];

export const SOURCE_PLATFORM_LABELS = PLATFORMS.reduce(
  (acc, platform) => {
    acc[platform.key] = platform.name;
    platform.aliases?.forEach((alias) => {
      acc[alias.toLowerCase()] = platform.name;
    });
    return acc;
  },
  {
    bookmyshow: "BookMyShow",
    district: "District",
    allevents: "AllEvents",
    eventbrite: "Eventbrite",
    platinumlist: "Platinumlist",
    platinumusit: "Platinumlist",
    showmates: "Showmates",
    bookmybeats: "BookMyBeats",
    ahmedabadmirror: "Ahmedabad Mirror",
    ahmedabadcity: "Ahmedabad City",
    gujaratevents: "Gujarat Events",
    other: "Booking site",
  },
);

export function extractCleanHostname(url) {
  if (!url || typeof url !== "string") return null;
  try {
    const parsed = new URL(url.startsWith("http") ? url : `https://${url}`);
    return parsed.hostname.replace(/^www\./, "").toLowerCase();
  } catch {
    return null;
  }
}

export function buildLogoDevUrl(domain) {
  if (!domain) return null;
  const clean = domain
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .split("/")[0];
  return `https://img.logo.dev/${encodeURIComponent(clean)}?token=${LOGO_DEV_TOKEN}&format=webp&retina=true`;
}

export function detectPlatform({ url, sourcePlatform } = {}) {
  const cleanUrl = typeof url === "string" ? url.trim() : "";
  const cleanSource =
    typeof sourcePlatform === "string"
      ? sourcePlatform
          .trim()
          .toLowerCase()
          .replace(/[\s_-]+/g, "_")
      : "";

  if (cleanUrl) {
    for (const platform of PLATFORMS) {
      if (platform.regexes?.some((rx) => rx.test(cleanUrl))) {
        return platform;
      }
    }

    const hostname = extractCleanHostname(cleanUrl);
    if (hostname) {
      for (const platform of PLATFORMS) {
        if (
          hostname === platform.domain.toLowerCase() ||
          hostname.endsWith(`.${platform.domain.toLowerCase()}`) ||
          platform.aliases?.some(
            (alias) =>
              hostname === alias.toLowerCase() ||
              hostname.endsWith(`.${alias.toLowerCase()}`),
          )
        ) {
          return platform;
        }
      }
    }
  }

  if (cleanSource) {
    for (const platform of PLATFORMS) {
      if (
        platform.key === cleanSource ||
        platform.key.replace(/_/g, "") === cleanSource.replace(/_/g, "") ||
        platform.aliases?.some(
          (alias) =>
            alias.toLowerCase().replace(/[\s_-]+/g, "_") === cleanSource ||
            alias.toLowerCase() === cleanSource,
        )
      ) {
        return platform;
      }
    }
  }

  return null;
}

export function getPlatformDisplayName({
  url,
  sourcePlatform,
  fallback = "booking site",
} = {}) {
  const platform = detectPlatform({ url, sourcePlatform });
  if (platform) return platform.name;

  if (url) {
    const host = extractCleanHostname(url);
    if (host) return host;
  }

  if (sourcePlatform && SOURCE_PLATFORM_LABELS[sourcePlatform.toLowerCase()]) {
    return SOURCE_PLATFORM_LABELS[sourcePlatform.toLowerCase()];
  }

  return fallback;
}
